export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/mezzopiano-icon.svg?30179c12e1b63d18f502f45f35ecef1d";